import React from 'react';
import Layout from '../components/Layout';
import ContactSection from '../components/ContactSection';
import '../styles/page-layout.css';

const PrivacyPage: React.FC = () => {
  return (
    <Layout
      title="Datenschutz | Stimm.DEV - Datenschutzerklärung"
      description="Datenschutzerklärung von Stimm.DEV - Informationen zum Umgang mit Ihren personenbezogenen Daten"
      keywords="Datenschutz, DSGVO, Privacy, Cookies, Stimm.DEV"
    >
      <section className="wrapper">
        <div className="page-container">
          <div className="page-header">
            <span className="section-title">Datenschutz</span>
            <h1>Datenschutzerklärung</h1>
            <p>Informationen zum Umgang mit Ihren personenbezogenen Daten</p>
          </div>

          <div className="page-content-card">
            
            <h2 id="ueberblick">1. Überblick über die Datenverarbeitung</h2>
            <h3>Verantwortliche Stelle</h3>
            <p>
              Henri Stimm<br />
              Kirchstraße 21<br />
              10557 Berlin<br />
              E-Mail: service@stimm.dev<br />
              Telefon: +49 30 42141523
            </p>

            <h3>Überblick über die Datenverarbeitung</h3>
            <p>
              Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und die Zwecke ihrer Verarbeitung zusammen und verweist auf die betroffenen Personen.
            </p>

            <h2 id="rechtsgrundlagen">2. Rechtsgrundlagen der Verarbeitung</h2>
            <p>
              Im Folgenden erhalten Sie eine Übersicht der Rechtsgrundlagen der DSGVO, auf deren Basis wir personenbezogene Daten verarbeiten:
            </p>
            <ul>
              <li>Art. 6 Abs. 1 S. 1 lit. a DSGVO - Einwilligung</li>
              <li>Art. 6 Abs. 1 S. 1 lit. b DSGVO - Erfüllung eines Vertrags</li>
              <li>Art. 6 Abs. 1 S. 1 lit. f DSGVO - Berechtigte Interessen</li>
            </ul>

            <h2 id="sicherheit">3. Sicherheitsmaßnahmen</h2>
            <p>
              Wir treffen nach Maßgabe der gesetzlichen Vorgaben unter Berücksichtigung des Stands der Technik, der Implementierungskosten und der Art, des Umfangs, der Umstände und der Zwecke der Verarbeitung sowie der unterschiedlichen Eintrittswahrscheinlichkeiten und des Ausmaßes der Bedrohung der Rechte und Freiheiten natürlicher Personen geeignete technische und organisatorische Maßnahmen.
            </p>

            <h2 id="datenarten">4. Übersicht der Verarbeitungen</h2>
            <h3>Arten der verarbeiteten Daten</h3>
            <ul>
              <li>Bestandsdaten</li>
              <li>Kontaktdaten</li>
              <li>Inhaltsdaten</li>
              <li>Nutzungsdaten</li>
              <li>Meta-/Kommunikationsdaten</li>
            </ul>

            <h3>Kategorien betroffener Personen</h3>
            <ul>
              <li>Interessenten</li>
              <li>Kommunikationspartner</li>
              <li>Kunden</li>
              <li>Nutzer</li>
            </ul>

            <h2 id="zwecke">5. Zwecke der Verarbeitung</h2>
            <ul>
              <li>Erbringung vertraglicher Leistungen und Kundenservice</li>
              <li>Kontaktanfragen und Kommunikation</li>
              <li>Sicherheitsmaßnahmen</li>
              <li>Verwaltung und Beantwortung von Anfragen</li>
              <li>Feedback</li>
              <li>Marketing</li>
              <li>Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit</li>
            </ul>

            <h2 id="cookies">6. Cookies und Webanalyse</h2>
            <h3>Cookies</h3>
            <p>
              Wir verwenden Cookies, um die Funktionalität unserer Website zu gewährleisten und Ihre Benutzererfahrung zu verbessern. Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden.
            </p>
            <p>
              Sie können Ihre Cookie-Einstellungen jederzeit über unseren Cookie-Dialog anpassen oder in Ihren Browser-Einstellungen ändern.
            </p>

            <h3>Chatwoot Live-Chat</h3>
            <p>
              Wir verwenden Chatwoot für unseren Live-Chat-Service. Dabei werden folgende Daten verarbeitet:
            </p>
            <ul>
              <li>Chat-Nachrichten</li>
              <li>Zeitstempel</li>
              <li>Browser-Informationen</li>
              <li>IP-Adresse (anonymisiert)</li>
            </ul>

            <h2 id="rechte">7. Rechte der betroffenen Personen</h2>
            <p>
              Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:
            </p>
            <ul>
              <li>Recht auf Auskunft</li>
              <li>Recht auf Berichtigung</li>
              <li>Recht auf Löschung</li>
              <li>Recht auf Einschränkung der Verarbeitung</li>
              <li>Recht auf Datenübertragbarkeit</li>
              <li>Widerspruchsrecht</li>
              <li>Recht auf Widerruf der datenschutzrechtlichen Einwilligung</li>
            </ul>

            <h2 id="speicherdauer">8. Speicherdauer</h2>
            <p>
              Wir speichern personenbezogene Daten nur so lange, wie es für die Erfüllung der verfolgten Zwecke erforderlich ist oder wie es gesetzlich vorgeschrieben ist.
            </p>

            <h2 id="hosting">9. Hosting und CDN</h2>
            <p>
              Unsere Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters / der Hoster gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
            </p>

            <h2 id="kontaktformular">10. Kontaktformular und E-Mail-Kontakt</h2>
            <p>
              Wenn Sie uns per Kontaktformular oder E-Mail kontaktieren, werden Ihre Angaben zur Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind.
            </p>

            </div>
        </div>
      </section>

      {/* Contact Section */}
      <ContactSection />
    </Layout>
  );
};

export default PrivacyPage;
